import React from "react";
import classNames from "classnames";
import Tooltip from "@mui/material/Tooltip";

import styles from "../projectDetails.module.scss";

const ProjectDetailsWithoutGroup = ({ field }) => {
  return (
    <div
      key={field.project_field_template_id}
      className={classNames(
        styles.infoCol,
        "pl-0 mb-3 pr-3",
        field?.big_box_text ? "w-50" : ""
      )}
    >
      <span className="small font-weight-bold">
        {field.field_name}
      </span>
      {field.field_type === "text" && (
        <div>
          {field.field_value?.length >
          (!field?.big_box_text ? 40 : 330) ? (
            <Tooltip
              title={field.field_value}
              placement="top"
              arrow
            >
              <span className="cursor-pointer">
                {field.field_value.slice(
                  0,
                  !field?.big_box_text ? 40 : 330
                )}
                ...
              </span>
            </Tooltip>
          ) : (
            <div className="caption mt-2">
              {field.field_value || "-"}
            </div>
          )}
        </div>
      )}
      {field.field_type === "dropdown" && (
        <div className="d-flex flex-column">
          {field.multiselect ? (
            field.option_selected?.length ? (
              field.option_selected.map((o, idx) => (
                <span
                  className="caption"
                  key={`${o}-${idx}`}
                >
                  {o}
                  {field.option_selected?.length === 1
                    ? ""
                    : field.option_selected?.length ===
                    idx + 1
                      ? ""
                      : ","}
                </span>
              ))
            ) : (
              "-"
            )
          ) : (
            <span className="caption">
              {field.option_selected.length
                ? field.option_selected[0]
                : field.field_value}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(ProjectDetailsWithoutGroup);
